/**
 * Canonical admin "view" routes for core entities.
 *
 * Centralized so that entity references across the app (a test name in a
 * "used in" list, a learning-path chip, a resource row) link to a real page
 * instead of rendering as dead text or a `#` dead click — and so the route
 * strings aren't re-typed at every call site.
 *
 * Each id-based builder returns `null` when the id is missing, so callers can
 * fall back to plain text rather than emitting a dead-end link:
 *
 *   const href = adminTestHref(test.id);
 *   return href ? <Link href={href}>{test.name}</Link> : <span>{test.name}</span>;
 */

const ADMIN_BASE = "/workspaces/admin";

export function adminTestHref(id) {
  return id != null ? `${ADMIN_BASE}/tests/${id}` : null;
}

export function adminLearningPathHref(id) {
  return id != null ? `${ADMIN_BASE}/learning-paths/${id}` : null;
}

export function adminResourceHref(id) {
  return id != null ? `${ADMIN_BASE}/resources/${id}` : null;
}

export function adminRolePlayHref(id) {
  return id != null ? `${ADMIN_BASE}/role-plays/${id}` : null;
}

export function adminPersonHref(id) {
  return id != null ? `${ADMIN_BASE}/people/${id}` : null;
}

// These have no per-item detail page yet — they link to the library index.
export function adminFaqsHref() {
  return `${ADMIN_BASE}/faqs`;
}

export function adminGlossaryHref() {
  return `${ADMIN_BASE}/glossary`;
}
